import { PersonCard } from "@/pages/ContactsPage/Components/PersonCard";
import { FillTheFieldErrorMessage } from "@/shared/Components";
import { contactsIsEditSelector } from "@/pages/ContactsPage/slice";
import { useAppSelector } from "@/services/store";
import type { PersonCardProps } from "@/pages/ContactsPage/Components/PersonCard";
import type { FC } from "react";
import styles from "./styles.module.scss";

type Props = Omit<PersonCardProps, "isEdit">;

export const ContactsPersonCard: FC<Props> = ({ ...props }) => {
  const isEdit = useAppSelector(contactsIsEditSelector);
  return (
    <div className={styles.wrapper}>
      <div className={styles.error}>
        <FillTheFieldErrorMessage name="generalAtLeast" />
      </div>
      <PersonCard isEdit={isEdit} {...props} />
    </div>
  );
};
